import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FiHome, FiCalendar, FiLogOut, FiMenu, FiX, FiUserCheck,
  FiHelpCircle
} from 'react-icons/fi';
import logo2 from "../../../assets/images/logo2.png";
import { MdOutlineRealEstateAgent, MdSell } from 'react-icons/md';
import { FaUsers, FaBlog, FaBars, FaUserCheck } from 'react-icons/fa';
import '../../../assets/css/sellers/sellersidebar/sellerssidebar.css';
import AppContext from 'context/AppContext';

// ── Sidebar menu items ──
const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <FiHome />, path: '/seller/dashboard' },
  { id: 'my-property', label: 'My Property', icon: <FiUserCheck />, path: '/seller/my-property' },
  { id: 'visitrequests', label: 'Visit Requests', icon: <FaUserCheck />, path: '/seller/visit-requests' },
  // { id: 'analytics', label: 'Analytics', icon: <MdSell />, path: '/seller/analytics' },
  { id: 'KYC', label: 'Submit KYC Request', icon: <MdOutlineRealEstateAgent />, path: '/seller/kyc' },
  { id: 'messages', label: 'Conversations', icon: <FaUsers />, path: '/seller/messages' },
  { id: 'help-support', label: 'Help & Support', icon: <FiHelpCircle />, path: '/seller/help-supports' },
];

// ── Derive active menu from current URL ──
const getActiveId = (pathname) => {
  const exact = menuItems.find(m => m.path === pathname);
  if (exact) return exact.id;
  const partial = menuItems.find(m => pathname.startsWith(m.path) && m.path !== '/seller/dashboard');
  if (partial) return partial.id;
  if (pathname === '/seller' || pathname === '/seller/') return 'dashboard';
  return '';
};

const SellerSidebar = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { setAuthToken } = useContext(AppContext);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const activeMenu = getActiveId(location.pathname);

  // Close mobile sidebar on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const handleMenuClick = (path) => {
    Navigate(path);
    if (window.innerWidth < 768) setIsMobileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('selleremail');
    localStorage.removeItem('sellerpassword');
    localStorage.removeItem("loggedInseller");
    Navigate('/seller/login');
  };

  

  return (
    <>
      {/* ── Mobile Toggle Button ── */}
      <button className="seller-mobile-menu-btn" onClick={() => setIsMobileOpen(s => !s)}>
        {isMobileOpen ? <FiX /> : <FiMenu />}
      </button>

      {/* ── Mobile Overlay ── */}
      {isMobileOpen && <div className="seller-sidebar-overlay" onClick={() => setIsMobileOpen(false)} />}

      {/* ── Sidebar ── */}
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>

        {/* Logo + Collapse Button */}
        <div className="seller-sidebar-header">
          {!isCollapsed && (
            <a href="/" className="navbar-brand">
            <img src={logo2} alt="Estate Experts" className="navbar-logo" />

            {/* Text block */}
            <div className="navbar-brand-text-wrap">
              <span className="footer-brand-text">Estate Experts</span>
              <span className="footer-brand-tagline">
                Buy
                <span className="brand-tagline-dot">◆</span>
                Sell
                <span className="brand-tagline-dot">◆</span>
                Rent
              </span>
            </div>
          </a>
          )}
          <button
            className="seller-sidebar-hamburger"
            onClick={() => setIsCollapsed(prev => !prev)}
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <FaBars />
          </button>
        </div>

        {/* Navigation */}
        <nav className="seller-sidebar-nav">
          <ul className="seller-menu-list">
            {menuItems.map(item => (
              <li key={item.id} className="seller-menu-item">
                <div
                  className={`seller-menu-link ${activeMenu === item.id ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item.path)}
                  title={isCollapsed ? item.label : ''}
                >
                  <span className="seller-menu-icon">{item.icon}</span>
                  {!isCollapsed && <span className="seller-menu-label">{item.label}</span>}
                  {isCollapsed && activeMenu === item.id && <span className="seller-active-dot" />}
                </div>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout */}
        <div className="seller-sidebar-footer">
          <button
            className="seller-logout-btn"
            onClick={handleLogout}
            title={isCollapsed ? 'Logout' : ''}
          >
            <span className="seller-menu-icon"><FiLogOut /></span>
            {!isCollapsed && <span className="seller-menu-label">Logout</span>}
          </button>
        </div>
      </div>
    </>
  );
};

export default SellerSidebar;